import { noOp } from '@treasury/utils';
import { IAnalyticsService } from './analytics.types';

export const NullAnalyticsService: IAnalyticsService = {
    init: () => Promise.resolve(),
    identify: noOp,
    reset: noOp,
    track: noOp,
    trackPageView: noOp,
};
